import React from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { filterTabs } from "../trendPageCommonFunction";
import { TabSelector } from "../../tabSelector/tabSelector";
import { useTranslation } from "react-i18next";
import { GRAPH_TYPE } from "../../../constants/trendGraph/trendGraphType";
import { DEFAULT_CUSTOM_CHART_KEY } from "../../../constants/trendGraph/charts";

export const DisplayTabSelector = (props) => {
  const { vesselId, currentVessel, selectedGraph, isSepVessel, defaultChart } = props;
  const { t } = useTranslation();
  const { NoME, NoDG, NoSG } = currentVessel || {};
  const navigate = useNavigate();

  const clickTab = (id) => {
    let chart = defaultChart(id);
    if (id==GRAPH_TYPE.CUSTOM && !chart) {
      chart = DEFAULT_CUSTOM_CHART_KEY;
    }
    navigate(`/trend/${id}/${chart}/${vesselId}`);
  };

  const filteredTab = filterTabs(isSepVessel, NoME, NoDG, NoSG, t);

  return (
    <TabSelector tabs={filteredTab} selectedOne={selectedGraph} clickHandler={clickTab} t={t} />
  );
};

DisplayTabSelector.propTypes = {
  vesselId: PropTypes.string,
  currentVessel: PropTypes.object,
  selectedGraph: PropTypes.string,
  isSepVessel: PropTypes.bool,
  defaultChart: PropTypes.func,
}